import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { FilterPanel } from '../../../generic/Filter';
import DepthFilter from './PackageFilters/DepthFilter';
import LayerFilter from './PackageFilters/LayerFilter';
import StatusFilter from './PackageFilters/StatusFilters';
import HasIssuesFilter from './PackageFilters/IssueFilter';
import PackageManagerFilter from './PackageFilters/PackageManagerFilter';
import LicenseFilter from './PackageFilters/LicenseFilter';
import RootProjectsFilter from './PackageFilters/RootProjectsFilter';
import styles from './Filters.module.less';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import { DependencyFilterKeys } from '../../../../../shared/dependenciesV2';
import PackageLabelsFilter from './PackageFilters/PackageLabelsFilter';
import { FeatureFlagRequired } from '../../../generic';
import { DISABLE_PACKAGE_LABELS } from '../../../../../shared/featureFlags/flagNames';

type Props = {
  isContainerProject: boolean;
  isReleaseGroupScope: boolean;
};

const DependencyFilters: VoidFunctionComponent<Props> = ({ isContainerProject, isReleaseGroupScope }) => {
  const stateFilters = useSelector(DependenciesV2Store.selectors.getFilters);
  const isOrgMember = useSelector(DependenciesV2Store.selectors.getIsOrgMember);
  return (
    <FilterPanel title="Package">
      <div className={styles.PackageFilters}>
        {isReleaseGroupScope && <RootProjectsFilter />}
        <StatusFilter />
        <DepthFilter />
        {isContainerProject && <LayerFilter />}
        <PackageManagerFilter />
        <FeatureFlagRequired flagName={DISABLE_PACKAGE_LABELS} isNotEnabled>
          <PackageLabelsFilter />
        </FeatureFlagRequired>
        {isOrgMember && (
          <HasIssuesFilter selectedOptions={stateFilters[DependencyFilterKeys.HasIssues]} />
        )}
        <LicenseFilter />
      </div>
    </FilterPanel>
  );
};

export default DependencyFilters;
